// extracted by mini-css-extract-plugin
export var addButton = "_f0-0";
export var border = "_f0-8";
export var check = "_f0-h";
export var danger = "_f0-6";
export var dropdownContainer = "_f0-1";
export var editModalBody = "_f0-j";
export var footerContainer = "_f0-i";
export var fullWidth = "_f0-a";
export var hide = "_f0-9";
export var icon = "_f0-3";
export var input = "_f0-7";
export var inputFlex = "_f0-b";
export var inputWrapper = "_f0-c";
export var manualFocus = "_f0-5";
export var optionButton = "_f0-4";
export var pillWrapper = "_f0-e";
export var pointer = "_f0-2";
export var showOverflow = "_f0-f";
export var tagsFlex = "_f0-d";
export var xButton = "_f0-g";